<template>
    <div>

        <mdc-menu-anchor>
            <mdc-button raised @click="isOpen=true">
                <i class="material-icons">more_vert</i></mdc-button>
            <mdc-menu v-model="isOpen">
                <mdc-menu-item v-if="showEdit">
                    <a @click.prevent="editItem(item)">
                        {{ 'user.edit' | trans }}
                    </a>
                </mdc-menu-item>
                <mdc-menu-item v-if="showDelete">
                    <a @click.prevent="showDeletePopup">
                        {{ 'user.delete' | trans }}
                    </a>
                </mdc-menu-item>
            </mdc-menu>
        </mdc-menu-anchor>

        <mdc-dialog v-model="isModalVisible"
                    :title="'user.confirm_delete' | trans"
                    :accept="'user.delete' | trans"
                    :cancel="'user.cancel' | trans"
                    @accept="deleteItem"
                    @cancel="onModalClose">
        </mdc-dialog>
    </div>

</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'ClientRow',
    props: {
      item: Object,
      showEdit: {
        type: Boolean,
        default() {
          return true;
        }
      },
      showDelete: {
        type: Boolean,
        default() {
          return true;
        }
      },
    },
    data() {
      return {
        isOpen: false,
        isModalVisible: false,
      };
    },
    methods: {
      close() {
        this.isOpen = false;
      },
      showDeletePopup(){
        this.isModalVisible = true
      },
      onModalClose () {
        this.isModalVisible = false
      },
      editItem() {
        this.close();
        this.$emit('editItem', this.item);
      },
      deleteItem() {
        this.close();
        this.$emit('deleteItem', this.item.id);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/client/components/ClientBtn.vue